import styled from 'styled-components';
import { Main } from '../../styles';
import { WhiteButton } from '../../components/Buttons/Buttons';

export const Container = styled.section`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(20deg,#512da8,#311b92  );
`;

export const MainContainer = styled(Main)`
  flex: 1;
  background-color: transparent;
  box-shadow: none;
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & h1 {
    color: white;
    font-size: 2.5em;
    margin-block-end: 0.3em;
  }
  & p {
    color: white;
    font-weight: bold;
  }
`;

export const PlayerContainer = styled(TextContainer)`
  flex-direction: row;
  max-width: 680px;
  flex-wrap: wrap;
`;

export const StartButton = styled(WhiteButton)`
  position: absolute;
  top: 80px;
  right: 20px;
`;

export const NameContainer = styled.div`
  min-width: 100px;
  width: fit-content;
  height: 50px;
  background-color: #311b92;
  text-align: center;
  padding: 0 10px;
  margin: 20px;
  & span {
    color: white;
    font-size: 1.5em;
    font-weight: bold;
    line-height: 50px;
  }

`;

export const PlayerNum = styled(NameContainer)`
  position: absolute;
  top: 80px;
  left: 20px;
  height: 40px;
  min-width: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0;
  justify-content: center;
  & span {
    line-height: 40px;
    margin: 2px;
    & svg {
      transform: translateY(10%);
    }
  }
`;
